export const sanitizeClipboardText = (value) => String(value ?? "").replace(/\t/g, " ").replace(/\r?\n/g, " ");

export const normalizeClipboardValue = (value) => {
  if (value == null) return "";
  if (isNaN(value)) return sanitizeClipboardText(value);
  return Number(value);
};

const parseLocalizedNumber = (value) => {
  if (typeof value === "number") {
    return Number.isFinite(value) ? value : NaN;
  }

  if (value == null) return NaN;

  const raw = String(value).trim();
  if (!raw) return NaN;

  const hasComma = raw.includes(",");
  const hasDot = raw.includes(".");

  let normalized = raw;

  if (hasComma && hasDot) {
    normalized =
      raw.lastIndexOf(",") > raw.lastIndexOf(".")
        ? raw.replace(/\./g, "").replace(",", ".")
        : raw.replace(/,/g, "");
  } else if (hasComma) {
    normalized = raw.replace(",", ".");
  }

  return Number(normalized);
};

export const formatClipboardDecimal = (
  value,
  { locale = "pt-BR", useGrouping = true, minimumFractionDigits = 2, maximumFractionDigits = 2 } = {}
) => {
  const parsedValue = parseLocalizedNumber(value);

  if (Number.isNaN(parsedValue)) {
    return sanitizeClipboardText(value);
  }

  return parsedValue.toLocaleString(locale, {
    useGrouping,
    minimumFractionDigits,
    maximumFractionDigits,
  });
};
